module.exports = ".div-top{\n    margin-top: 20px;\n}\n\n@media (min-width: 1450px) {\n    .titulo-processo-text {\n        font-size: 35px;\n    }\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pergunta-documentos/pergunta-documentos.component.css
// module id = ./src/app/pergunta-documentos/pergunta-documentos.component.css
// module chunks = main